<template>
    <div class="mb-12">
        <v-app-bar color="white" fixed class="mb-12 px-4">
            <v-toolbar-title>
                <v-img src="/logo.png" contain width="100px" height="60px" @click="goHome()" style="pointer:cusor"></v-img>
            </v-toolbar-title> 
            <v-spacer></v-spacer>
                <v-avatar size="30">
                    <img :src="getImageUrl(userById.profile_img_url)">
                </v-avatar>
            <v-menu bottom left offset-y transition="slide-y-transition">
                <template v-slot:activator="{ on }">
                <v-icon v-on="on" small class="mt-5">mdi-chevron-down</v-icon>
                
                </template>

                <v-list>
                <v-list-item router-link to="/" style="text-decoration:none">
                    <v-list-item-icon>
                    <v-icon color="#033953">mdi-home</v-icon>
                    </v-list-item-icon>
                    <v-item-content>
                    <v-list-item-title style="color:#033953; font-size:14px" >
                        HOME
                    </v-list-item-title> 
                    </v-item-content>
                </v-list-item>
                <v-list-item router-link to="/profile" style="text-decoration:none">
                    <v-list-item-icon>
                    <v-icon color="#033953">mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-item-content>
                    <v-list-item-title style="color:#033953; font-size:12px" >
                        PROFILE
                    </v-list-item-title> 
                    </v-item-content>
                </v-list-item>
                
                <v-list-item @click="logout()" style="text-decoration:none">
                    <v-list-item-icon>
                    <v-icon color="#033953">mdi-power</v-icon>
                    </v-list-item-icon>
                    <v-item-content>
                    <v-list-item-title style="color:#033953; font-size:12px" >
                        LOGOUT
                    </v-list-item-title> 
                    </v-item-content>
                </v-list-item>
                </v-list>
            </v-menu>
            <v-menu bottom right offset-y transition="scale-transition">
                <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-3" v-on="on">
                        <v-icon large color="#48c074">mdi-apps</v-icon>
                    </v-btn>
                </template>  

                <v-list class="py-4">
                    <v-list-item router-link to="/dashboard" style="text-decoration:none">
                        <v-list-item-icon>
                            <v-icon color="#48c074">mdi-apps</v-icon>
                        </v-list-item-icon>
                        <v-item-content>
                            <v-list-item-title style="color:#48c074; font-size:14px">
                                DASHBOARD 
                            </v-list-item-title> 
                        </v-item-content>
                    </v-list-item>
                    <v-divider class="my-0"></v-divider> 
                    <v-list-item router-link to="/farms" style="text-decoration:none">
                        <v-list-item-icon>
                            <v-icon color="#48c074">mdi-tree-outline</v-icon>
                        </v-list-item-icon>
                        <v-item-content>
                            <v-list-item-title style="color:#48c074; font-size:14px">
                                FARMS
                            </v-list-item-title> 
                        </v-item-content>
                    </v-list-item>
                    <v-divider class="my-0"></v-divider> 
                    <v-list-item router-link to="/transactions" style="text-decoration:none">
                        <v-list-item-icon>
                            <v-icon color="#48c074">mdi-finance</v-icon>
                        </v-list-item-icon>
                        <v-item-content>
                            <v-list-item-title style="color:#48c074; font-size:14px">
                                TRANSACTIONS
                            </v-list-item-title> 
                        </v-item-content>
                    </v-list-item>
                    <v-divider class="my-0"></v-divider>
                    
                </v-list>
            </v-menu>
        </v-app-bar>             
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    methods:{
        logout(){
            this.$store.dispatch("AUTH_LOGOUT")
            .then(()=>{
                window.localStorage.removeItem("vuex")
                this.$router.push('/login');
            })
            .catch(()=>{
            })
        },
        getImageUrl(url){
            if(url!==""&&url!=='undefined'&&url!==null){
                return url
            }else{
                return('/pics.svg')
            }
        },
        goHome(){
            this.$router.push('/')
        }
    },
    computed:{
        userById(){
          let user= this.$store.state.auth.logindetails.data
          user.date_created = user.date_created.slice(0, 19).replace('T', ' ')
          return user
        }
    },
    
}
</script>